import React from "react";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import { Typography, InputAdornment, Box } from "@mui/material";
import { themes } from "services/constants";

export const CustomAutoCompleteWithStaticLabel = ({
  dataList,
  selectedValue,
  Icons,
  updateDataFunction,
  rules,
  placeHolder,
  label,
  staticLabel,
  errorMessage,
  textBoxError,
  disableAction,
  sx,
}) => {
  return (
    <Box sx={{ position: "relative", width: "100%" }}>
      <Autocomplete
        disablePortal
        id="combo-box"
        size="small"
        value={selectedValue}
        options={dataList}
        sx={{
          width: "100%",
          "& .MuiAutocomplete-inputRoot": {
            paddingLeft: staticLabel ? "70px !important" : "8px !important",
          },
          ...sx,
        }}
        ListboxProps={{ style: { maxHeight: "150px" } }}
        filterOptions={(options, state) => {
          return options.filter((option) =>
            (option?.label || option?.name || "")
              .toString()
              .toLowerCase()
              .includes(state.inputValue.toLowerCase()),
          );
        }}
        getOptionLabel={(option) => {
          if (!option) return "";
          if (typeof option === "string") return option;
          return option.label || option.name || "";
        }}
        renderOption={(props, option) => (
          <li {...props}>{option?.label || option?.name || option}</li>
        )}
        isOptionEqualToValue={(option, value) => {
          if (!option || !value) return false;
          if (typeof option === "string" || typeof value === "string") {
            return (
              option === value ||
              option === value?.label ||
              value === option?.label
            );
          }
          return (
            option?.label === value?.label ||
            option?.name === value?.name ||
            option?.id === value?.id
          );
        }}
        onChange={(event, value) => updateDataFunction(event, value)}
        disabled={disableAction}
        renderInput={(params) => (
          <TextField
            {...params}
            placeholder={placeHolder}
            size="small"
            error={textBoxError}
            helperText={errorMessage}
            fullWidth
            InputProps={{
              ...params.InputProps,
              startAdornment: (
                <InputAdornment
                  position="start"
                  sx={{
                    mr: 0.5,
                    position: "absolute",
                    left: "8px",
                    zIndex: 1,
                  }}
                >
                  {Icons && (
                    <Icons style={{ fontSize: "18px", color: "#7c98b6" }} />
                  )}
                </InputAdornment>
              ),
            }}
            sx={{
              background: themes.whiteColor,
              "& .MuiOutlinedInput-root": {
                "& fieldset": { border: "none" },
              },
            }}
          />
        )}
      />

      {/* Static Label Overlay */}
      {staticLabel && (
        <Box
          sx={{
            position: "absolute",
            left: Icons ? "42px" : "14px",
            top: "50%",
            transform: "translateY(-50%)",
            pointerEvents: "none",
            zIndex: 2,
          }}
        >
          <Typography
            sx={{
              fontSize: "13px",
              color: "#7c98b6",
              whiteSpace: "nowrap",
              fontWeight: 500,
            }}
          >
            {staticLabel} :
          </Typography>
        </Box>
      )}
    </Box>
  );
};
